<i18n>
  {
    "en": {
      "Link": "Link",
      "Copy": "Copy"
    },
    "de": {
      "Link": "Link",
      "Copy": "Kopieren"
    }
  }
</i18n>
<template>
  <div class="d-flex align-items-center">
    <div class="mr-3">
      <a
        :href="url"
        class="text-info"
        target="_blank"
      >{{ $t('Link') }}</a>
    </div>
    <input readonly class="form-control" ref="urlInput" :value="url">
    <b-button
      variant="primary"
      class="ml-2"
      @click="clipboardCopy($refs.urlInput)"
    >{{ $t('Copy') }}</b-button>
  </div>
</template>

<script>
export default {
  name: 'CopyLink',
  props: {
    url: String,
  },
  methods: {
    clipboardCopy(inputElem) {
      inputElem.select();
      document.execCommand('copy');
    },
  }
}
</script>

<style lang="scss" scoped>
input {
    background-color: white !important;
}
</style>
